import React from 'react';
import { motion } from 'framer-motion';

const GOLD = '#c9a44a';
const BLUE = '#5b7cfa';

const randomBetween = (min, max) => Math.random() * (max - min) + min;

// A wandering flight path that roams across most of the viewport, looping back to origin
const makeFlightPath = () => {
	const vw = typeof window !== 'undefined' ? window.innerWidth : 1440;
	const vh = typeof window !== 'undefined' ? window.innerHeight : 900;
	const rangeX = vw * 0.38;
	const rangeY = vh * 0.38;
	const waypoints = 6;
	const xs = Array.from({ length: waypoints }, () => randomBetween(-rangeX, rangeX));
	const ys = Array.from({ length: waypoints }, () => randomBetween(-rangeY, rangeY));
	return { x: [0, ...xs, 0], y: [0, ...ys, 0] };
};

const RUNE_DEFS = [
	{ char: 'ᚠ', color: GOLD },
	{ char: 'ᚱ', color: BLUE },
	{ char: 'ᚦ', color: GOLD },
	{ char: 'ᛟ', color: BLUE },
	{ char: 'ᛉ', color: GOLD },
	{ char: 'ᛏ', color: BLUE },
	{ char: 'ᚨ', color: GOLD },
	{ char: 'ᚷ', color: BLUE },
	{ char: 'ᚺ', color: GOLD },
	{ char: 'ᛁ', color: BLUE },
	{ char: 'ᛈ', color: GOLD },
	{ char: 'ᛗ', color: BLUE },
];

// Precomputed once per page load — each rune starts somewhere random and wanders its own random path
const RUNES = RUNE_DEFS.map((rune, i) => ({
	...rune,
	left: randomBetween(4, 88),
	top: randomBetween(8, 80),
	delay: i * 0.4 + randomBetween(0, 0.8),
	glowDelay: randomBetween(0, 2.2),
	flightPath: makeFlightPath(),
	floatDur: randomBetween(16, 28),
}));

const FloatingRunes = () => (
	<div className="hidden lg:block absolute inset-0 z-[3] pointer-events-none" aria-hidden="true">
		{RUNES.map((rune, i) => (
			<motion.div
				key={i}
				className="absolute"
				style={{ left: `${rune.left}%`, top: `${rune.top}%` }}
				animate={{ x: rune.flightPath.x, y: rune.flightPath.y }}
				transition={{
					duration: rune.floatDur,
					repeat: Infinity,
					ease: 'easeInOut',
					delay: rune.delay,
				}}
			>
				<motion.div
					className="font-display select-none"
					style={{ fontSize: '2.75rem', color: rune.color }}
					animate={{
						opacity: [0.15, 0.15, 1, 0.2, 0.9, 0.15],
						scale: [0.9, 0.9, 1.1, 0.95, 1.05, 0.9],
						filter: [
							`drop-shadow(0 0 2px ${rune.color})`,
							`drop-shadow(0 0 2px ${rune.color})`,
							`drop-shadow(0 0 16px ${rune.color})`,
							`drop-shadow(0 0 3px ${rune.color})`,
							`drop-shadow(0 0 12px ${rune.color})`,
							`drop-shadow(0 0 2px ${rune.color})`,
						],
					}}
					transition={{
						duration: 5,
						repeat: Infinity,
						ease: 'easeInOut',
						delay: rune.glowDelay,
						times: [0, 0.3, 0.4, 0.55, 0.7, 1],
					}}
				>
					{rune.char}
				</motion.div>
			</motion.div>
		))}
	</div>
);

export default FloatingRunes;
